const Field = require("components/forms/Field");

function Select({label, error, errorMessage, className, options, inputRef, required, children, ...props}) {
	return (
		<Field label={label} error={error} errorMessage={errorMessage} className={className} required={required}>
			<select ref={inputRef} {...props}>
				{options.map(opt => {
					let disabled = opt.disabled === true ? true : false;
					return (<option key={opt.value} value={opt.value} disabled={disabled}>{opt.label}</option>);
				})}
			</select>
			{children}
		</Field>
	);
}

module.exports = Select;



// WEBPACK FOOTER //
// ./resources/js/components/forms/Select.js